<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" @close="closeModal">
      <div class="fixed inset-0 z-30 overflow-y-auto">
        <div class="min-h-screen text-center flex">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-10"
            leave="duration-200 ease-in"
            leave-from="opacity-10"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
          </TransitionChild>

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-50"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-50"
          >
            <div
              class="inline-block w-full mx-3 md:w-1/3 md:mx-auto max-w-screen-md m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded overflow-y-scroll"
            >
              <div class="flex flex-row">
                <div class="flex-1"></div>
                <div
                  class="flex-4 pr-2 pt-2 cursor-pointer"
                  @click="closeModal(false)"
                >
                  <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                </div>
              </div>

              <div class="pb-2 px-5 md:px-8">
                <h2 class="text-xl text-brand-black py-1">
                  Change Application{{ bundles.length === 1 ? "" : "s" }} Owner
                </h2>
              </div>

              <div class="py-2 px-5 md:px-8 flex flex-col">
                <div class="flex flex-col">
                  <label for="username" class="block text-brand-black">
                    Change
                    {{
                      bundles.length === 1
                        ? "this application"
                        : "these applications"
                    }}
                    owner to
                  </label>
                  <SingleLineInput
                    id="username"
                    type="text"
                    :placeholder="`Enter agent's email`"
                    :value="username"
                    @input="username = $event.target.value"
                  ></SingleLineInput>
                </div>
              </div>

              <div
                class="px-5 py-5 md:px-8 flex flex-col md:flex-row justify-between w-full"
              >
                <div class="py-1">
                  <SecondaryButton
                    :classes="'border-brand-mid-gray'"
                    @click="closeModal(false)"
                    >Cancel</SecondaryButton
                  >
                </div>
                <div class="py-1">
                  <PrimaryButton @click="changeOwner">Change</PrimaryButton>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import { mapGetters } from "vuex"
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay
} from "@headlessui/vue"

import { APPLICATION_BUNDLE_CHANGE_OWNER } from "@/store/types"

import { XIcon } from "@heroicons/vue/outline"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    bundles: {
      type: Array
    }
  },
  emit: ["close"],
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  computed: {
    ...mapGetters(["isApplicationBundleLoading"])
  },
  data() {
    return {
      username: ""
    }
  },
  methods: {
    closeModal(reload = false) {
      this.$emit("close", reload)
    },
    async changeOwner() {
      const { username } = this
      const bundleSlugs = this.bundles.map((bundle) => bundle.slug)
      try {
        await this.$store.dispatch(APPLICATION_BUNDLE_CHANGE_OWNER, {
          username,
          bundles: bundleSlugs
        })
        this.closeModal(true)
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
<style scoped></style>
